import { createAuthClient } from 'better-auth/react';
import { emailOTPClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [emailOTPClient()],
});

export const {
  useSession,
  signIn,
  signUp,
  signOut,
  linkSocial,
  // Email-OTP: send/verify a verification code, and the change-email sub-flow
  // (requestEmailChange -> changeEmail). Namespace is `authClient.emailOtp.*`.
  emailOtp,
  // Change password (requires current password) — Settings -> Profile modal.
  changePassword,
  // Forgot-password flow: request a reset email, then set a new password with the
  // emailed token. `requestPasswordReset` triggers the reset email; `resetPassword`
  // consumes `{ token, newPassword }` and returns without a session (the reset page
  // re-signs-in afterward for the auto-login UX).
  requestPasswordReset,
  resetPassword,
} = authClient;
